import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const tab = ({ palette, spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiTab"] => ({
	root: {
		opacity: "1",
		backgroundColor: "transparent",
		borderRadius: spacing(0.5),
		minHeight: spacing(5),
		fontSize: spacing(1.75),
		letterSpacing: "0.015em",
		minWidth: 0,
		maxWidth: "none",
		padding: `${spacing(0.5)} ${spacing(3)}`,
		fontWeight: 600,
		fontFamily: "RoobertCEZ",
		"@media (min-width: 600px)": {
			minWidth: 0,
			maxWidth: "none",
		},
	},
	textColorPrimary: {
		opacity: 1,
		color: palette.white,
		"&.Mui-selected": {
			backgroundColor: palette.white,
			color: palette.darkBlue,
		},
	},
});

export default tab;
